const es = {
  // Navbar
  nav_product: "Producto",
  nav_pricing: "Precios",
  nav_integrations: "Integraciones",
  nav_dashboard: "Dashboard",

  // Hero
  hero_badge: "Plataforma IA · Disponible 24/7/365",
  hero_title_1: "Nunca pierdas",
  hero_title_2: "otra llamada",
  hero_subtitle: "Tu recepcionista con IA responde, agenda y captura leads en 31 idiomas, mientras tú te concentras en hacer crecer tu negocio.",
  hero_subtitle_highlight: "en 31 idiomas",
  hero_ai_name: "Recepcionista IA",
  hero_ai_company: "Clínica Salud Avanzada",
  hero_status_active: "En llamada",
  hero_ai_greeting: "\"Buenos días, Clínica Salud Avanzada. ¿En qué puedo ayudarle hoy?\"",
  hero_user_message: "\"Necesito una cita con el Dr. Martínez para esta semana...\"",
  hero_checking_calendar: "Consultando disponibilidad ISO 8601...",
  hero_cta_demo: "Ver Demo Interactiva",
  hero_cta_register: "Empezar Gratis",
  hero_disclaimer: "Sin tarjeta de crédito · Configuración en 3 minutos · Cancela cuando quieras",
  hero_stat_calls: "Llamadas gestionadas",
  hero_stat_uptime: "Uptime SLA",
  hero_stat_savings: "Ahorro vs call center",
  hero_stat_languages: "Idiomas nativos",
  hero_scroll_hint: "Descubre más",

  // How it works
  how_label: "Cómo funciona",
  how_title_1: "De la llamada a la cita",
  how_title_2: "en menos de 60 segundos",
  how_subtitle: "Flujo completamente autónomo. Tu equipo no interviene. Cada paso ocurre en tiempo real.",
  how_total_time: "Tiempo total del flujo completo:",
  how_total_time_value: "menos de 60 segundos",
  how_live_simulation: "Simulación en vivo",
  how_step_label: "PASO",
  how_appointment_confirmed: "¡Cita confirmada!",
  how_email_sent: "Email enviado",
  how_sms_sent: "SMS enviado",
  how_incoming_call: "Llamada entrante",
  how_check_availability: "Verificando disponibilidad...",

  // Pricing
  pricing_label: "Modelo de Precios",
  pricing_title_1: "Precio transparente,",
  pricing_title_2: "valor exponencial",
  pricing_subtitle: "Sin sorpresas. Sin letra pequeña. Cancela en cualquier momento.",
  pricing_monthly: "Mensual",
  pricing_annual: "Anual",
  pricing_per_month: "/mes",
  pricing_billed_annual: "Facturado",
  pricing_per_year: "€/año",
  pricing_secure: "Pago seguro con Stripe · Cancela cuando quieras",
  pricing_redirecting: "Redirigiendo...",
  pricing_error: "No se pudo iniciar el pago. Inténtalo de nuevo.",
  pricing_error_connection: "Error de conexión. Por favor, inténtalo de nuevo.",
  pricing_enterprise: "¿Necesitas un plan Enterprise personalizado?",
  pricing_enterprise_cta: "Habla con nuestro equipo",
  pricing_popular_badge: "MÁS POPULAR",
  pricing_period: "mes",

  // FAQ
  faq_label: "Preguntas Frecuentes",
  faq_title_1: "Respuestas directas a las",
  faq_title_2: "objeciones reales de compra",
  faq_subtitle: "Sin marketing. Sin rodeos. Aquí están las respuestas a lo que realmente te preguntas antes de contratar.",
  faq_cat_all: "Todos",
  faq_cat_technology: "Tecnología",
  faq_cat_privacy: "Privacidad",
  faq_cat_config: "Configuración",
  faq_cat_business: "Negocio",
  faq_cat_compatibility: "Compatibilidad",
  faq_cat_implementation: "Implementación",
  faq_cat_integrations: "Integraciones",
  faq_unanswered_title: "¿Tu pregunta no está aquí?",
  faq_unanswered_desc: "Nuestro equipo responde en menos de 2 horas en horario laboral. Sin bots, sin formularios eternos.",
  faq_contact_cta: "Escribir al equipo",

  // Wall of Love
  wol_label: "Wall of Love",
  wol_title_1: "Empresas que ya nunca",
  wol_title_2: "pierden una llamada",
  wol_cta_title: "Únete a más de 1.200 empresas que confían en Auria",
  wol_cta_desc: "Valoración media de 4.9/5 en G2 y Capterra · Sin contratos de permanencia",
  wol_cta_btn: "Ver Planes y Precios",

  // CTA Section
  cta_badge: "Empieza hoy · Sin riesgo",
  cta_title_1: "Captura cada oportunidad.",
  cta_title_2: "Empieza en 3 minutos.",
  cta_subtitle: "Más de 1.200 empresas ya han eliminado las llamadas perdidas para siempre. Tu competencia probablemente ya lo está evaluando.",
  cta_btn_register: "Empezar Gratis",
  cta_btn_demo: "Ver Demo",
  cta_disclaimer: "14 días de prueba gratis · Sin tarjeta de crédito · Sin compromiso",
  cta_trust_1: "Datos 100% seguros y cifrados",
  cta_trust_2: "Setup en menos de 3 minutos",
  cta_trust_3: "Soporte 24/7 en español",

  // Footer
  footer_desc: "Auria es la plataforma de recepcionistas con IA que elimina las llamadas perdidas para siempre. Disponible 24/7/365 en 31 idiomas.",
  footer_newsletter_title: "Recibe actualizaciones del producto",
  footer_newsletter_placeholder: "tu@email.com",
  footer_subscribe_success: "¡Suscrito correctamente!",
  footer_subscribe_error: "Error al suscribirse. Inténtalo de nuevo.",
  footer_copyright: "© 2026 Auria. Todos los derechos reservados.",
  footer_status: "Todos los sistemas operativos · 99.7% uptime",
  footer_col_product: "Producto",
  footer_col_company: "Empresa",
  footer_col_legal: "Legal",

  // Footer links
  footer_features: "Características",
  footer_pricing: "Precios",
  footer_integrations: "Integraciones",
  footer_changelog: "Changelog",
  footer_roadmap: "Roadmap",
  footer_about: "Sobre nosotros",
  footer_blog: "Blog",
  footer_use_cases: "Casos de uso",
  footer_contact: "Contacto",
  footer_manage_sub: "Gestionar suscripción",
  footer_privacy: "Privacidad",
  footer_terms: "Términos de uso",
  footer_cookies: "Cookies",
  footer_gdpr: "GDPR",
  footer_sla: "SLA",

  // Register modal
  register_title: "Empieza gratis",
  register_subtitle: "Tu recepcionista IA en menos de 3 minutos",
  register_name_label: "Nombre completo",
  register_name_placeholder: "Tu nombre",
  register_email_label: "Email",
  register_email_placeholder: "tu@empresa.com",
  register_business_label: "Empresa",
  register_business_placeholder: "Nombre de tu empresa",
  register_phone_label: "Teléfono (opcional)",
  register_phone_placeholder: "+34 600 000 000",
  register_cta: "Crear cuenta gratis",
  register_sending: "Enviando...",
  register_success_title: "¡Bienvenido a Auria!",
  register_success_desc: "Hemos enviado un email de confirmación. Nuestro equipo te contactará en menos de 24h para configurar tu recepcionista IA.",
  register_demo_link: "Ver demo interactiva mientras esperas",
  register_disclaimer: "Sin tarjeta de crédito · Cancela cuando quieras",
  register_or_see_plans: "¿Prefieres ver los planes? Ir a precios",
  register_error: "Error al enviar. Por favor inténtalo de nuevo.",

  // Demo modal
  demo_title: "Demo Interactiva",
  demo_close: "Cerrar",

  // Cookie banner
  cookie_title: "Usamos cookies",
  cookie_desc: "Utilizamos cookies propias y de terceros para mejorar tu experiencia y analizar el uso de la web.",
  cookie_accept: "Aceptar todas",
  cookie_reject: "Solo esenciales",
  cookie_policy: "Política de cookies",

  // 404
  not_found_title: "Página no encontrada",
  not_found_desc: "La página que buscas no existe o ha sido movida.",
  not_found_cta: "Volver al inicio",

  // Cuenta page
  cuenta_loading: "Cargando...",
  cuenta_not_found: "Suscripción no encontrada",

  // Bienvenida page
  welcome_title: "¡Bienvenido a Auria!",

  // AI labels in HowItWorks
  ai_detecting: "Detectando idioma...",
  ai_querying: "Consultando RAG...",
  ai_analyzing: "Analizando intención...",
  ai_generating: "Generando respuesta...",

  // Vision Section
  vision_label: "Visión Estratégica",
  vision_title: "El coste real de una llamada sin respuesta",
  vision_p1: "En 2026, el consumidor moderno penaliza cualquier segundo de espera. Las soluciones basadas en personal humano enfrentan cuellos de botella estructurales que ninguna empresa puede permitirse ignorar.",
  vision_p2: "Las organizaciones que automatizan la atención telefónica logran una mejora de eficiencia de hasta el <strong>80%</strong>, transformando procesos que antes tomaban días en resoluciones de minutos.",
  vision_insight_title: "Insight de mercado 2026",
  vision_insight_desc: "El 67% de los clientes que no son atendidos nunca vuelven a llamar al mismo negocio.",

  // Canvas Memory form (bienvenida)
  cm_title_business: "Datos del negocio",
  cm_business_name_label: "Nombre del negocio *",
  cm_business_name_placeholder: "Ej: Clínica Dental Martínez",
  cm_business_type_label: "Tipo de negocio *",
  cm_business_type_placeholder: "Ej: Clínica dental, Asesoría fiscal, Peluquería...",
  cm_email_contact_label: "Tu email de contacto *",
  cm_address_label: "Dirección",
  cm_address_placeholder: "Calle, número, ciudad",
  cm_title_schedule: "Horario de atención",
  cm_mon_fri_label: "Lunes a viernes",
  cm_mon_fri_placeholder: "Ej: 9:00 – 14:00 / 16:00 – 20:00",
  cm_sat_label: "Sábados",
  cm_sat_placeholder: "Ej: 10:00 – 14:00 / Cerrado",
  cm_sun_label: "Domingos y festivos",
  cm_sun_placeholder: "Ej: Cerrado",
  cm_title_services: "Servicios y precios",
  cm_service_label: "Servicio",
  cm_price_label: "Precio",
  cm_service_name_placeholder: "Nombre del servicio",
  cm_price_placeholder: "Ej: 60€",
  cm_other_services_label: "Otros servicios (si los hay)",
  cm_other_services_placeholder: "Lista aquí el resto de servicios con sus precios...",
  cm_title_appointments: "Protocolo de citas",
  cm_duration_label: "Duración media de cada cita",
  cm_duration_placeholder: "Ej: 45 minutos",
  cm_confirmation_label: "¿Se requiere confirmación 24h antes?",
  cm_select_option: "Selecciona...",
  cm_cancellation_label: "Política de cancelación",
  cm_cancellation_placeholder: "Ej: Avisar con 24h de antelación",
  cm_title_faq: "Preguntas frecuentes de tus clientes",
  cm_question_label: "Pregunta",
  cm_question_placeholder: "¿Qué pregunta suelen hacer tus clientes?",
  cm_answer_placeholder: "Respuesta que debe dar la IA",
  cm_title_extra: "Información adicional",
  cm_extra_placeholder: "Cualquier dato importante que la IA deba conocer: aparcamiento, formas de pago, zonas de cobertura, idiomas...",
  cm_max_chars: "Máx. 500 caracteres",
  cm_submit_btn: "Enviar Canvas Memory",
  cm_sending: "Enviando...",
  cm_success_title: "¡Canvas Memory enviado!",
  cm_success_desc: "En menos de 24h configuramos tu IA con estos datos. Puedes marcar el paso como completado.",
  cm_hint_title: "¿Para qué sirve esto?",
  cm_hint_desc: "El Canvas Memory es la memoria de tu IA. Cuanto más detallado lo rellenes, mejor responderá tu IA a las preguntas de tus clientes sobre horarios, precios y citas.",

  // ValueProposition
  vp_label: "Propuesta de Valor",
  vp_title_1: "Por qué las mejores empresas",
  vp_title_2: "eligen la IA sobre el humano",
  vp_subtitle: "No es un IVR. Es un sistema de ejecución autónoma diseñado para capturar cada oportunidad de negocio.",
  vp_arch_title: "Arquitectura de ejecución autónoma",
  vp_arch_desc: "Canvas Memory con RAG en tiempo real: cualquier cambio en el conocimiento de tu negocio se inyecta en el agente al instante. Sin reentrenamiento, sin esperas.",

  // ComparisonSection
  comp_label: "Comparativa",
  comp_title_1: "La diferencia es",
  comp_title_2: "difícil de ignorar",
  comp_subtitle: "Compara punto a punto lo que te cuesta el modelo actual frente a lo que ganas con VoiceAI.",
  comp_without: "Sin VoiceAI",
  comp_with: "Con VoiceAI",
  comp_cta: "Ver precios",

  // DashboardSection
  dash_label: "Panel de Control",
  dash_title_1: "Tu negocio,",
  dash_title_2: "bajo control total",
  dash_subtitle: "Gestiona tu recepcionista IA desde un dashboard minimalista inspirado en Stripe. Tres métricas de impacto real, Canvas Memory para editar el conocimiento de tu IA en tiempo real, y control total sobre las transferencias a humanos.",
  dash_f1_title: "Canvas Memory (RAG en tiempo real)",
  dash_f1_desc: "Edita el conocimiento de tu IA en vivo. Los cambios se aplican instantáneamente.",
  dash_f2_title: "Agenda con protocolo ISO 8601",
  dash_f2_desc: "Sin conflictos de zona horaria. Disponibilidad verificada antes de proponer cada slot.",
  dash_f3_title: "Transferencia a humanos contextual",
  dash_f3_desc: "Detección semántica de casos VIP y emergencias para escalar al equipo en el momento justo.",
  dash_tab_demo: "Demo en vivo",
  dash_tab_dashboard: "Dashboard",
  dash_repeat_demo: "Repetir demo",
  dash_client_label: "Dashboard · Clínica Ejemplo",
  dash_calls_title: "Llamadas por mes",
  dash_calls_growth: "+96% anual",
  dash_recent_calls: "Últimas llamadas",
  dash_vs_prev: "vs mes anterior",

  // TechArchitectureSection
  tech_label: "Arquitectura Técnica",
  tech_title_1: "Sistema Multiagente",
  tech_title_2: "TB-CSPN Framework",
  tech_subtitle: "No es un simple LLM. Es una arquitectura de ejecución multiagente estructurada en tres capas funcionales que orquestan cada llamada con precisión quirúrgica.",
  tech_memory_label: "Infraestructura de Memoria",
  tech_mem1_title: "ChromaDB — Memoria Semántica",
  tech_mem1_desc: "RAG del negocio: horarios, FAQs, catálogo de servicios inyectados en contexto",
  tech_mem2_title: "Memoria Episódica",
  tech_mem2_desc: "La IA recuerda a cada cliente recurrente y el contexto de llamadas pasadas",
  tech_mem3_title: "Accumulative Learning",
  tech_mem3_desc: "Las llamadas exitosas evolucionan automáticamente la base de conocimiento",
  tech_mcp_title: "MCP — Model Context Protocol",
  tech_mcp_desc: "El «USB-C de la IA»: conecta de forma segura a cualquier CRM, base de datos externa o sistema empresarial sin reescribir código.",
  tech_stack_label: "Stack Tecnológico",

  // VoicePipelineSection
  voice_label: "Procesamiento de Voz",
  voice_title_1: "Latencia sub-segundo.",
  voice_title_2: "Naturalidad absoluta.",
  voice_subtitle: "Una pausa de más de un segundo destruye la confianza del usuario. Nuestro pipeline Audio Speech-to-Speech procesa la voz de extremo a extremo en menos de 1 segundo.",
  voice_simulating: "Simulando...",
  voice_start_sim: "Iniciar simulación",
  voice_pipeline_title: "Realtime Audio Pipeline",
  voice_ws_title: "WebSocket Bridge",
  voice_ws_desc: "Arquitectura desacoplada: cambia de proveedor de voz (Kokoro → ElevenLabs) sin tocar la lógica de negocio",
  voice_a2a_title: "Audio-to-Audio Nativo",
  voice_a2a_desc: "Sin conversión intermedia a texto. El pipeline procesa la señal de voz directamente para mínima latencia",
  voice_agnostic_title: "Provider Agnostic",
  voice_agnostic_desc: "Integración modular: OpenAI Realtime, ElevenLabs, Kokoro TTS. El cliente Premium elige su engine de voz",
  voice_delivery_title: "Deliverability y Answer Rates",
  voice_delivery_desc: "De nada sirve una IA perfecta si la llamada llega marcada como SPAM. Implementamos la cadena completa de verificación de identidad del llamante.",
  voice_answer_rate: "+40% de tasa de respuesta en llamadas salientes con Branded Caller ID activado",

  // SecurityEvolutionSection
  sec_label: "Seguridad y Escalabilidad",
  sec_title_1: "Construido para los datos",
  sec_title_2: "más sensibles del mundo",
  sec_subtitle: "En el manejo de datos de voz, el cumplimiento normativo es la piedra angular de la confianza empresarial. Diseñado desde cero para HIPAA y RGPD.",
  sec_privacy_title: "Seguridad y Privacidad",
  sec_residency_title: "Data Residency Europa",
  sec_residency_desc: "Todos los datos almacenados en Frankfurt (EU-CENTRAL-1). Nunca salen de la Unión Europea.",
  sec_learning_title: "Ciclo Construir-Colaborar-Evolucionar",
  sec_learning_badge: "Accumulative Learning",
  sec_learning_quote: "«Cada llamada exitosa hace al sistema más inteligente»",
  sec_episodic_note: "Las Memorias Episódicas Positivas (llamadas exitosas validadas por el operador) se transfieren automáticamente al RAG principal, creando un sistema que evoluciona orgánicamente con cada interacción sin necesidad de reentrenamiento manual.",
  sec_episodic_strong: "Memorias Episódicas Positivas",
  sec_blueprint_badge: "Conclusión del Blueprint",
  sec_blueprint_title: "MVP comercial de alta fidelidad",
  sec_blueprint_desc: "Este sistema integra orquestación multiagente TB-CSPN, latencia sub-segundo y una estrategia de marketing basada en la transparencia radical. Entregamos no solo tecnología, sino tiempo y tranquilidad: garantizamos que cada llamada se convierta en una oportunidad capitalizada.",
  sec_blueprint_strong: "tiempo y tranquilidad",
  sec_bp_arch: "Arquitectura Multiagente",
  sec_bp_latency: "Latencia de respuesta",
  sec_bp_calendar: "Gestión de agenda",
  sec_bp_pii: "Datos en transcripciones",

  // IntegrationsSection
  int_label: "Integraciones y Seguridad",
  int_title_1: "Se integra con todo",
  int_title_2: "lo que ya usas",
  int_subtitle: "Conecta tu stack tecnológico en minutos. Sin código, sin fricción.",
  int_counter: "Más de 50 integraciones nativas disponibles · REST API abierta",
  int_sec_badge: "Seguridad Enterprise",
  int_sec_title: "Construido para los sectores más regulados",
};

export default es;
